// src/pages/Step4.js
import React from "react";
import { Container, Card } from "../components/Layout";
import ProgressButton from "../components/ProgressButton";
import styled from "styled-components";

const Message = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
  margin: 10px 0;
`;

function Step4({ bmi, riskFactors, onNext, onBack }) {
  // const isEligible = () => {
  //   // If BMI indicates eligibility OR at least one risk factor is selected, eligible for treatment
  //   return riskFactors.length > 0;
  // };

  return (
    <Container>
      <Card>
        <h1>Evaluering</h1>
        <Message>Du er egnet til behandling.</Message>
        <div>
          <ProgressButton text="Tilbage" onClick={onBack} />
          <ProgressButton text="Videre til kontraindikation" onClick={onNext} />
        </div>
      </Card>
    </Container>
  );
}

export default Step4;
